import { apiPathServer } from './api-config';
import { CgiResp } from './cgi';
import { API_PREFIX, request } from './request';

/**
 * 获取图片颜色
 */
export const getColorsFromAi = async (imageUrl: string) => {
  const res = await request<CgiResp<{
    code: number
    primary: string;
    complementary: string
  }>>(`${API_PREFIX}${apiPathServer.getColor}`, {
    method: 'POST',
    body: {
      image_url: imageUrl,
    },
  });
  return res;
};
